import APIUtil from "../config/APIUtil";
import UrlConstants from "../config/UrlConstants";
import * as code from "../config/Constants";
// import * as types from "./actions";
// import * as message from "../config/CommonMessages";

/**
 * 30-6-2023
 * generarting answer from tellagent ai api, sanding the question and getting the output.
 */
export function genratingAnswerfromTellagentApi(data) {
  // console.log("data22", data);
  // console.log("UrlConstants.TellagentAiApi", UrlConstants.TellagentAiApi);
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.TellagentAiApi, data, true).then(
      (response) => {
        return response;
      }
    );
  };
}

/**
 * 30-6-2023
 * generarting answer from tellagent ai api, sanding the question and getting the output.
 */
export function fetchquestionAnswerhistory(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.fetchQAHistory, data, true).then(
      (response) => {
        return response;
      }
    );
  };
}

/**
 * 18-7-2023
 * updating ai settings.
 */
export function updateAisettings(data) {
  // console.log("22420", data);
  return function(dispatch) {
    return APIUtil.putMethod(UrlConstants.updateAisettings, data, true).then(
      (response) => {
        return response;
      }
    );
  };
}

/**
 * 18-7-2023
 * get ai settings.
 */
export function getAisettings() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.getAisettings, true).then(
      (response) => {
        if (response.status == code.OK) {
        } else {
        }
        return response;
      }
    );
  };
}

/**
 * 18-7-2023
 * updating ai settings.
 */
export function updateAiModel(data) {
  // console.log("22420", data);
  return function(dispatch) {
    return APIUtil.putMethod(UrlConstants.updategptmodel, data, true).then(
      (response) => {
        return response;
      }
    );
  };
}

/**
 * get ai model
 * 19-7-2023
 */

export function getAimodel() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.getaimodel, true).then((response) => {
      if (response.status == code.OK) {
      } else {
      }
      return response;
    });
  };
}

export function addAiVersions(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.addAiVersions, data, true).then(
      (response) => {
        if (response.status === code.OK) {
          return response;
        } else {
          return response;
        }
      }
    );
  };
}

export function updateAiVersions(data) {
  return function(dispatch) {
    return APIUtil.putMethod(UrlConstants.editAiVersons, data, true).then(
      (response) => {
        if (response.status === code.OK) {
          return response;
        } else {
          return response;
        }
      }
    );
  };
}

/**
 *
 * @desc Get all ai versions
 * 2024-06-18
 */
export function getAllAiVersions() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.getAllAiVersions, true).then(
      (response) => {
        if (response.status === code.OK) {
          return response;
        } else {
          return [];
        }
      }
    );
  };
}

/**
 *
 * @desc Update status for ai versions
 * 2024-06-20
 */

export function updateAiVersionStatus(data) {
  var url = UrlConstants.updateAiVersionStatusUrl;
  return function(dispatch) {
    return APIUtil.putMethod(url, data, true).then((response) => {
      return response;
    });
  };
}

//--------------------------- Prompt APIs start ---------------------------
/**
 *
 * @desc Get all ai prompts for listing
 *
 */

export function getAiPromptsListAction(recordPerPage, pageIndex, categoryId, order) {
  var url = UrlConstants.getAiPromptListUrl;

  let data = {
    limit: recordPerPage,
    offset: pageIndex,
    sort: "subCategory",
    order: order,
    categoryId: categoryId,
  };
  // console.log("getAiPromptsListAction", data);

  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      return response;
    });
  };
}

/**
 *
 * get ai prompt details
 */
export function getAiPromptDetailsAction(id) {
  let url = UrlConstants.getAiPromptDetailsUrl;
  url = url.replace("{id}", id);
  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status == code.OK) {
      } else {
      }
      return response;
    });
  };
}

/**
 *
 * add ai prompt details
 */
export function addAiPromptAction(data) {
  let url = UrlConstants.addAiPromptUrl;
  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      if (response.status == code.OK) {
      } else {
      }
      return response;
    });
  };
}

/**
 *
 * update ai prompt details
 */
export function updateAiPromptAction(data, id) {
  let url = UrlConstants.updateAiPromptUrl;
  url = url.replace("{id}", id);
  return function(dispatch) {
    return APIUtil.putMethod(url, data, true).then((response) => {
      if (response.status == code.OK) {
      } else {
      }
      return response;
    });
  };
}

/**
 *
 * @desc Update status or default flag of ai prompt
 *
 */

export function updateAiPromptStatusAction(data) {
  var url = UrlConstants.updateAiPromptStatusUrl;
  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      return response;
    });
  };
}

//--------------------------- Prompt APIs end ---------------------------

//--------------------------- Category APIs start ---------------------------
/**
 *
 * get ai categories.
 */
export function getAiCategoriesAction() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.categoryUrl, true).then(
      (response) => {
        if (response.status == code.OK) {
        } else {
        }
        return response;
      }
    );
  };
}

/**
 *
 * @desc Get all category listing with pagination
 *
 */

export function getAllCatPaginateAction(recordPerPage, pageIndex) {
  var url = UrlConstants.categoryUrl + "/getCategoryListing";

  let data = {
    limit: recordPerPage,
    offset: pageIndex,
  };

  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      return response;
    });
  };
}

/**
 *
 * @desc add category
 *
 */

export function addCategoryAction(data) {
  var url = UrlConstants.categoryUrl;
  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      return response;
    });
  };
}

/**
 *
 * @desc update category
 *
 */

export function updateCategoryAction(data, id) {
  var url = UrlConstants.categoryUrl + "?id=" + id;
  return function(dispatch) {
    return APIUtil.putMethod(url, data, true).then((response) => {
      return response;
    });
  };
}

/**
 *
 * get category details
 */
export function getOneCatDetailsAction(id) {
  let url = UrlConstants.getOneAiCatUrl;
  url = url.replace("{id}", id);
  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status == code.OK) {
      } else {
      }
      return response;
    });
  };
}

/**
 *
 * @desc update status of category
 *
 */

export function updateCatStatusAction(data) {
  var url = UrlConstants.updateCategoryStatusUrl;
  return function(dispatch) {
    return APIUtil.putMethod(url, data, true).then((response) => {
      return response;
    });
  };
}

//--------------------------- Category APIs end ---------------------------

//--------------------------- Sub Category APIs start ---------------------------
/**
 *
 * get ai sub categories .
 */
export function getAiSubCategoriesAction() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.subCategoryUrl, true).then(
      (response) => {
        if (response.status == code.OK) {
        } else {
        }
        return response;
      }
    );
  };
}

/**
 *
 * get ai category's sub category .
 */
export function getAiCatSubAction(categoryId) {
  let url = UrlConstants.getAiCatSubUrl;
  url = url.replace("{categoryId}", categoryId);
  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status == code.OK) {
      } else {
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get all category subcategory listing with pagination
 *
 */

export function getAllSubCatPaginateAction(recordPerPage, pageIndex) {
  var url = UrlConstants.subCategoryUrl;

  let data = {
    limit: recordPerPage,
    offset: pageIndex,
  };

  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      return response;
    });
  };
}

/**
 *
 * @desc add sub category
 *
 */

export function addSubCategoryAction(data) {
  var url = UrlConstants.subCategoryUrl + "/add";
  return function(dispatch) {
    return APIUtil.postMethod(url, data, true).then((response) => {
      return response;
    });
  };
}

/**
 *
 * @desc update sub category
 *
 */

export function updateSubCategoryAction(data, id) {
  var url = UrlConstants.updateSubCategoryUrl;
  url = url.replace("{id}", id);
  return function(dispatch) {
    return APIUtil.putMethod(url, data, true).then((response) => {
      return response;
    });
  };
}

/**
 *
 * get sub category details
 */
export function getOneSubCatDetailsAction(id) {
  let url = UrlConstants.getAiOneSubCategoryUrl;
  url = url.replace("{id}", id);
  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status == code.OK) {
      } else {
      }
      return response;
    });
  };
}

/**
 *
 * @desc update status of sub category
 *
 */

export function updateSubCatStatusAction(data) {
  var url = UrlConstants.updateSubCategoryStatusUrl;
  return function(dispatch) {
    return APIUtil.putMethod(url, data, true).then((response) => {
      return response;
    });
  };
}

//--------------------------- Sub Category APIs end ---------------------------




export function getAiServices() {
  //console.log("Calling getAiServices API:", UrlConstants.getAiserviceUrl);
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.getAiserviceUrl, true)
      .then((response) => {
        //console.log("getAiServices API Response:", response);
        return response;
      })
      .catch((error) => {
       // console.error("getAiServices API Error:", error);
        throw error;
      });
  };
}

export function GetAllAssignedVersion() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.getAllAiAssignedVersions, true).then(
      (response) => {
        if (response.status == code.OK) {
        } else {
        }
        return response;
      }
    );
  };
}



export function updateAiVersionToService(data) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.updateAiAssignedVersionUrl,
      data,
      true
    ).then((response) => {
      return response;
    });
  };
}




export function addAiVersionToparticularService(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.addAiAssignedVersionUrl,
      data,
      true
    ).then((response) => {
      return response;
    });
  };
}